import React from 'react'
import PropTypes from 'prop-types'

import { DashboardChartPaper, DonutChart } from 'components'

import theme from 'theme'

const PublicPrivacyPolicyByPortal = ({ privacyPolicies, id, ...rest }) => {
  const data = privacyPolicies?.reduce(
    (acc, privacyPolicy) => {
      if (privacyPolicy.publicDocument && privacyPolicy.acceptedCollect)
        acc[2]++
      else if (privacyPolicy.publicDocument) acc[0]++
      else if (privacyPolicy.acceptedCollect) acc[1]++
      else acc[3]++

      return acc
    },
    [0, 0, 0, 0],
  )

  return (
    <DashboardChartPaper
      title="Quantidade de Documentos Publicados nos Portais"
      subtitle="Portal de privacidade, na plataforma e em ambos"
      heightContainer="fit-content"
      {...rest}
    >
      <DonutChart
        legendShow
        names={['Portal de Privacidade', 'APP', 'Ambos', 'Nenhum']}
        values={data}
        title="Processos"
        colors={[
          theme.palette.dashboard.chart.privacyPolicy.privacyPortal,
          theme.palette.dashboard.chart.privacyPolicy.app,
          theme.palette.dashboard.chart.privacyPolicy.both,
          theme.palette.dashboard.chart.privacyPolicy.none,
        ]}
        showName={false}
        id={id}
      />
    </DashboardChartPaper>
  )
}

PublicPrivacyPolicyByPortal.propTypes = {
  privacyPolicies: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
}

export default PublicPrivacyPolicyByPortal
